import { SystemSlipType } from '../bet-generation/slip-type';

export interface ISystemBetPickState {
    isSelected: boolean;
    isBanker: boolean;
    isLocked: boolean;
    order: number;
}

export interface ISystemBetState {
    picks: { [pickId: string]: ISystemBetPickState };
    isEachWay: boolean;
    systemInfo: SystemSlipType | null;
    stake: number | null;
    isBankerActive: boolean;
    isBankerEnabled: boolean;
    actualStake: string | null;
    linearTypeStakes: Record<string, ISystemBetTypeStake>;
    isLinearExpanded: boolean;
}

export interface ISystemBetTypeStake {
    slipType: SystemSlipType;
    isEachWay: boolean;
    stake: number | null;
    actualStake: string | null;
    betCount: number;
}

export interface ISystemBetSavedState extends Omit<ISystemBetState, 'systemInfo'> {
    systemInfo: {
        key: string;
        name: string;
        basis: number[];
    } | null;
}

export const defaultSystemBetState: ISystemBetState = {
    picks: {},
    isEachWay: false,
    systemInfo: null,
    stake: 0,
    isBankerActive: false,
    isBankerEnabled: false,
    actualStake: '0',
    linearTypeStakes: {},
    isLinearExpanded: false,
};
